import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { usePartnerInterest } from "areas/partners/fabric";

import Box from "ui/atom/Box";

import Features from "areas/home/ui/Features";
import Layout from "areas/home/ui/Layout";
import Partners from "areas/home/ui/Partners";
import Button from "ui/base/Button";
import List from "ui/base/List";


Interest.Banner = () => {
	const partner = usePartnerInterest();
	const theme = useTheme();

	const style = {
		root: {
			textAlign: "center",
			maxWidth: "sm",
			mt: theme.spacing(10),
			mx: "auto"
		},
		title: {
			fontSize: { xs: 32, sm: 44 }
		},
		description: {
			whiteSpace: "break-spaces",
			textAlign: "justify"
		},
		list: { listStyleType: "disc", ml: 5 },
		button: {
			mx: "auto"
		}
	};
	return (
		<Box.Column gap={4} sx={style.root}>
			<Box.Column gap={1}>
				<Typography variant="h1" sx={style.title}>{partner.subscribe.title}</Typography>
				<Box.Column>
					<Typography variant="body1" sx={style.description}>{partner.subscribe.description}</Typography>
					<List sx={style.list}>
						{partner.subscribe.list.map((item, key) => <List.Item dense sx={{ display: "list-item" }} key={key}>{item}</List.Item>)}
					</List>
				</Box.Column>
			</Box.Column>
			<Button.Link to={partner.subscribe.to} variant="contained" color="tertiary" sx={style.button}>{partner.subscribe.action}</Button.Link>
		</Box.Column>
	);
};

export default function Interest() {
	const partner = usePartnerInterest();

	return (
		<Layout>
			<Interest.Banner />
			<Partners partners={partner.data} />
			<Features title="Partner Benefits" features={partner.features} />
		</Layout>
	);
}